import React from 'react';
import { ClipboardIcon, LayoutIcon } from 'shared/ui/icons';

export const TABS = [
  {
    label: 'Ringkasan',
    value: 'RINGKASAN',
    icon: <ClipboardIcon color="#64748b" />,
  },
  {
    label: 'Detail',
    value: 'DETAIL',
    icon: <LayoutIcon color="#64748b" />,
  },
];

export const INITIAL_COLLAPSE_STATE = {
  polis: false,
  waiting: false,
  disease: false,
  kontestasi: false,
  claim: false,
};

export const DISEASE_EXCLUSIONS = [
  'Penyakit tertentu 10 bulan pertama (katarak, asma, jantung, stroke, hepatitis, diabetes, hernia, tumor jinak, dll.).',
  'Bunuh diri, tindak kriminal, perang/kerusuhan/terorisme.',
  'Kanker <90 hari pertama.',
  'Gigi & mata non-darurat, operasi kosmetik/plastik, penurunan berat badan.',
  'Kehamilan, persalinan, kontrasepsi, infertilitas, disfungsi seksual.',
  'Cacat bawaan, penyakit bayi < 2 thn.',
  'Suplemen/vitamin tanpa indikasi medis.',
  'Penyalahgunaan obat/alkohol, sanatorium, isolasi penyakit tertentu.',
  'COVID-19 non-rumah sakit kerja sama.',
  'Perawatan preventif, biaya non-medis.',
  'Gangguan mental, HIV/AIDS, penyakit menular seksual.',
  'Olahraga ekstrem, radiasi nuklir. Sunat non-medis.',
  'Santunan kematian dikecualikan pada kasus tertentu (bunuh diri < 2 thn, hukuman mati, kejahatan).',
];
